// extracted by mini-css-extract-plugin
export var accentcolor = "#4eff00";
export var copyright = "Copyright-module--copyright--89f9c";
export var description = "Copyright-module--description--e74c2";
export var star = "Copyright-module--star--2c27d";